import { render, staticRenderFns } from "./FourDGanttChart.vue?vue&type=template&id=61dfafea&scoped=true"
import script from "./FourDGanttChart.vue?vue&type=script&lang=js"
export * from "./FourDGanttChart.vue?vue&type=script&lang=js"
import style0 from "./FourDGanttChart.vue?vue&type=style&index=0&id=61dfafea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61dfafea",
  null
  
)

export default component.exports